import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { GoogleCallbackPage } from '@/features/auth';

/**
 * Google returns the browser here with `code` and `state`. No redirect for a signed-in visitor:
 * finishing the exchange replaces the session cookie.
 */
export const Route = createFileRoute('/(public)/auth/google/callback')({
  validateSearch: z.object({
    code: z.string().optional(),
    state: z.string().optional(),
    error: z.string().optional(),
    dev: z.string().optional(),
  }),
  component: GoogleCallbackRoute,
});

function GoogleCallbackRoute() {
  const { code, state, error, dev } = Route.useSearch();
  return <GoogleCallbackPage code={code} state={state} error={error} dev={dev === '1'} />;
}
